import { render, staticRenderFns } from "./PageBg.vue?vue&type=template&id=4ca6d9de&scoped=true"
import script from "./PageBg.vue?vue&type=script&lang=js"
export * from "./PageBg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca6d9de",
  null
  
)

export default component.exports